
import { defineComponent, PropType, ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { IProject } from '@/store/cvInterfaces'
import ModalTechStack from '@/components/cv/modal/ModalTechStack.vue'
import ModalMixin from '@/components/cv/modal/ModalMixin.vue'
import ModalPager from '@/components/cv/modal/ModalPager.vue'
import ModalNavCloseBtn from '@/components/cv/modal/ModalNavCloseBtn.vue'
import TheProjectsModalContent from '@/components/cv/modal/TheProjectsModalContent.vue'
import CvSectionLoader from '@/components/cv/CvSectionLoader.vue'

export default defineComponent({
  mixins: [ModalMixin],
  components: {
    TheProjectsModalContent,
    ModalTechStack,
    ModalPager,
    ModalNavCloseBtn,
    CvSectionLoader
  },
  props: {
    isLoading: {
      type: Boolean,
      default: true
    },
    data: {
      type: Array as PropType<IProject[]>,
      required: true,
    },
  },
  setup() {
    const projectsModalVisible = ref(false)
    const projectsModalIndex = ref(0)
    const router = useRouter()
    const route = useRoute()
    const routeHash = route.hash
    if (routeHash === '#projects') {
      projectsModalVisible.value = true
      projectsModalIndex.value = 0
      router.replace({ path: '/' })
    } else if (routeHash.includes('-')) {
      const [key, val] = routeHash.split('-')
      if (key === '#projects') {
        projectsModalVisible.value = true
        projectsModalIndex.value = parseInt(val || '0')
        router.replace({ path: '/' })
      }
    }

    watch(
      () => route.hash,
      async (routeHash) => {
        const [key, val] = routeHash.split('-')
        if (key === '#projects') {
          projectsModalVisible.value = true
          router.replace({ path: '/' })
          projectsModalIndex.value = parseInt(val || '0')
        }
      }
    )
    const showProjectsModal = (index: number, flag = true) => {
      projectsModalVisible.value = flag
      projectsModalIndex.value = index
    }

    return {
      showProjectsModal,
      projectsModalVisible,
      projectsModalIndex,
    }
  },
})
